import jwtDecode from 'jwt-decode'

import callApi from './apiActions'
import { requestClients } from './clientsActions'
import { requestLocations } from './locationsActions'

export const authFromToken = () => {
    return dispatch => {
        dispatch({ type: 'REQUEST_AUTH' })

        return dispatch(callApi('post', 'auth', {}))
            .then(data => {
                localStorage.setItem('token', data.payload)
                const decoded = jwtDecode(data.payload)

                dispatch({
                    type: 'REQUEST_AUTH_SUCCESS',
                    payload: { user: decoded.user, token: data.payload }
                })

                dispatch(requestClients())
                dispatch(requestLocations())
            })
            .catch(err => {
                localStorage.removeItem('token')
                dispatch({ type: 'REQUEST_AUTH_FAIL' })
            })
    }
}

// Chainable, have to .catch errors
export const logIn = (user, pass) => {
    return dispatch => {
        return dispatch(callApi('post', 'login', {
            user: user,
            pass: pass
        }))
            .then(data => {
                localStorage.setItem('token', data.payload)
                const decoded = jwtDecode(data.payload)

                dispatch({
                    type: 'REQUEST_AUTH_SUCCESS',
                    payload: { user: decoded.user, token: data.payload }
                })

                dispatch(requestClients())
                dispatch(requestLocations())
            })
            .catch(err => {
                throw err
            })
    }
}

export const logOut = () => {
    localStorage.removeItem('token')
    return { type: 'LOGOUT' }
}


// WEBPACK FOOTER //
// ./src/actions/authActions.js